import { Megaphone, ExternalLink } from "lucide-react";
import { ADS } from "@/lib/ads";

export const SuggestedChip = ({ active, onClick }) => (
  <button
    data-testid="market-cat-suggested"
    onClick={onClick}
    className={`relative shrink-0 rounded-full p-[1.5px] transition-transform active:scale-95 bg-gradient-to-r from-[#F59E0B] via-[#EC4899] to-[#8B5CF6] ${active ? "shadow-[0_0_16px_rgba(236,72,153,0.45)]" : ""}`}
  >
    <span className={`flex items-center gap-1.5 rounded-full px-3 py-[5px] text-xs font-semibold ${active ? "bg-transparent text-white" : "bg-[#121212] text-[#FBCFE8]"}`}>
      <Megaphone className="h-3 w-3" />
      Suggested
    </span>
    {!active && <span className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-[#EC4899] animate-pulse" />}
  </button>
);

const AdCard = ({ ad }) => (
  <a
    href={ad.url}
    target="_blank"
    rel="noopener noreferrer sponsored"
    data-testid={`suggested-ad-${ad.id}`}
    className="block snap-start rounded-2xl overflow-hidden bg-[#121212] border border-[#1E1E1E] hover:border-[#EC4899]/50 transition-colors"
  >
    <div className="flex items-center gap-2.5 px-3.5 py-3">
      <div className="h-8 w-8 rounded-full p-[1.5px] bg-gradient-to-tr from-[#F59E0B] via-[#EC4899] to-[#8B5CF6]">
        <div className="h-full w-full rounded-full bg-[#121212] flex items-center justify-center text-xs font-semibold text-white">
          {(ad.sponsor || "?").charAt(0).toUpperCase()}
        </div>
      </div>
      <div className="min-w-0">
        <div className="text-sm font-semibold text-[#F3F4F6] truncate">{ad.sponsor}</div>
        <div className="text-[10px] text-[#9CA3AF]">Sponsored</div>
      </div>
    </div>
    <img src={ad.image} alt={ad.title || ad.sponsor} loading="lazy" className="w-full aspect-[4/5] object-cover bg-black" />
    <div className="flex items-center justify-between gap-3 px-3.5 py-3 border-t border-[#1E1E1E]">
      <span className="text-sm text-[#F3F4F6] truncate">{ad.title}</span>
      <span className="shrink-0 flex items-center gap-1 text-xs font-semibold text-[#F472B6]">
        {ad.cta || "Learn more"} <ExternalLink className="h-3 w-3" />
      </span>
    </div>
  </a>
);

export const SuggestedFeed = () => (
  <section data-testid="suggested-feed" className="max-w-md mx-auto w-full">
    <h3 className="text-[10px] uppercase tracking-wider text-[#F472B6] mb-3 flex items-center gap-1.5">
      <Megaphone className="h-3.5 w-3.5" /> Suggested for you
    </h3>
    {ADS.length === 0 ? (
      <div data-testid="suggested-empty" className="rounded-2xl bg-[#121212] border border-dashed border-[#27272A] py-16 px-6 text-center">
        <div className="mx-auto mb-4 h-12 w-12 rounded-full p-[1.5px] bg-gradient-to-tr from-[#F59E0B] via-[#EC4899] to-[#8B5CF6]">
          <div className="h-full w-full rounded-full bg-[#121212] flex items-center justify-center">
            <Megaphone className="h-5 w-5 text-[#F472B6]" />
          </div>
        </div>
        <h4 className="font-heading text-lg font-semibold text-[#F3F4F6] mb-1.5">No adverts yet</h4>
        <p className="text-sm text-[#9CA3AF]">Suggested picks from our partners will show up here soon.</p>
      </div>
    ) : (
      <div className="space-y-5 snap-y">
        {ADS.map((ad) => <AdCard key={ad.id} ad={ad} />)}
      </div>
    )}
  </section>
);
